/**
 * Shared inline error banner used by admin/page-level mutation surfaces to
 * report `actionError` rejections (4xx/5xx) from create/update/delete
 * mutations. Centralizes the markup that previously lived inline across
 * UserDetailPage, ExtraCostPage, and several other pages so the dismiss UI
 * stays consistent. (F4-002 / F4-006 introduced the third copy of this
 * exact JSX — extraction lifts it to a single source of truth.)
 */
interface DismissibleErrorBannerProps {
  message: string | null;
  onDismiss: () => void;
  role?: string;
}

export function DismissibleErrorBanner({ message, onDismiss, role }: DismissibleErrorBannerProps) {
  if (!message) return null;
  return (
    <div
      role={role}
      className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-start justify-between"
    >
      <p className="text-sm text-red-800">{message}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="text-red-600 hover:text-red-800 text-sm ml-3"
      >
        Dismiss
      </button>
    </div>
  );
}
